'use strict';

exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; } /* eslint-disable react/no-danger, import/no-dynamic-require */


var SvgIcon = function SvgIcon(_ref) {
  var name = _ref.name,
      className = _ref.className,
      rest = _objectWithoutProperties(_ref, ['name', 'className']);

  return _react2.default.createElement('div', _extends({
    className: 'SvgIcon ' + className,
    dangerouslySetInnerHTML: { __html: require('li-icons/dist/js/' + name) }
  }, rest));
};

SvgIcon.propTypes = process.env.NODE_ENV !== "production" ? {
  name: _propTypes2.default.string.isRequired,
  className: _propTypes2.default.string
} : {};

SvgIcon.defaultProps = {
  className: ''
};

exports.default = SvgIcon;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/li-components/lib/SvgIcon/index.js
// module id = 79
// module chunks = 14